<template>
    <div :class="divClass">
        <p class="m-0">{{ label }}</p>
            <div class="d-flex py-2" v-for="(r, idx) in rows" :key="idx">
                <InputText
                    class="mx-2"
                    type="text"
                    v-model="r[0]"
                    :placeholder="keyPlaceholder"
                    @input="updateKey($event, idx)"
                    :disabled="isNonEditableKey"
                />
                <InputText
                    class="mx-2"
                    type="text"
                    v-model="r[1]"
                    :placeholder="valuePlaceholder"
                    @input="updateValue($event, idx)"
                    :disabled="isNonEditableValue"
                />
                <div class="mx-2 d-flex align-items-center px-2 add-btn" role="button" v-if="isAppendable==true && idx === 0" @click="addRow">
                    <i class="pi pi-plus main-color"></i>
                </div>
                <div class="mx-2 d-flex align-items-center px-2 remove-btn" role="button" v-if="isRemoveable == true && idx !== 0" @click="removeRow(idx)">
                    <i class="pi pi-minus vi-red"></i>
                </div>
            </div>
    </div>
</template>

<script>
import map from 'lodash/map'
export default {
    name: 'KeyValueCollector',
    components: { },
    props: {
        value: {
            type: Array,
            default: () => [['', '']]
        },
        label: {
            type: String,
            default: ''
        },
        keyPlaceholder: {
            type: String,
            default: 'Key'
        },
        valuePlaceholder: {
            type: String,
            default: 'Value'
        },
        divClass: {
            type: String,
            default: ''
        },
        isNonEditableKey: {
            type: Boolean,
            default: false
        },
        isNonEditableValue: {
            type: Boolean,
            default: false
        },
        isRemoveable: {
            type: Boolean,
            default: true
        },
        isAppendable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            rows: map(this.value, (v) => [v[0], v[1], Date.now() + '.' + parseInt(Math.random() * 10000)])
        }
    },
    watch: {
        value () {
            this.rows = map(this.value, (v) => [v[0], v[1], Date.now() + '.' + parseInt(Math.random() * 10000)])
        }
    },
    methods: {
        _cleanedRows () {
            return map(this.rows, (v) => [v[0], v[1]])
        },
        addRow () {
            this.rows.push(['', '', Date.now() + '.' + parseInt(Math.random() * 10000)])
            this.$emit('updatePair', this._cleanedRows())
        },
        removeRow (idx) {
            this.rows.splice(idx, 1)
            this.$emit('updatePair', this._cleanedRows())
        },
        updateKey () {
            this.$emit('updatePair', this._cleanedRows())
        },
        updateValue () {
            this.$emit('updatePair', this._cleanedRows())
        }
    }
}
</script>

<style scoped>
.add-btn {
    border-radius: 0.3rem;
    border: 1px solid var(--primary-color);
}
.remove-btn {
    border-radius: 0.3rem;
    border: 1px solid #EE2737;
}
</style>
